module.exports = __webpack_public_path__ + "img/179995.e409444b.png";